/***********************
 * VARIABLES GLOBALES
 ***********************/
const popup = document.getElementById("location-popup-section");
const content = document.getElementById("location-popup-content");
const closeBtn = document.getElementById("location-popup-close");
const submitBtn = document.getElementById("location-submit");
const navegadorBtn = document.getElementById("location-navegador");
const changeLocationBtn = document.getElementById("change-location-btn");
const contentInfo = document.getElementById("content-info");


const geoApifyKey = "24da6212d08f413fb105d86ae26461e9";

let map = null;
let marker = null;
let selectedCoords = null;
let selectedAddress = "";
let selectedCity = "";
let selectedGeoData = null;



function hideContentInfo() {
  if (contentInfo && !contentInfo.classList.contains("is-hidden")) {
    contentInfo.classList.add("is-hidden");
  }
}


/***********************
 * POPUP CONTROL
 ***********************/
if (!localStorage.getItem("userAddress")) {
  popup.style.display = "flex";
}

changeLocationBtn?.addEventListener("click", () => {
  popup.style.display = "flex";

});

closeBtn.addEventListener("click", () => {
   localStorage.removeItem("pendingAddToCart");
  popup.style.display = "none";
});

popup.addEventListener("click", (e) => {
  if (
    !content.contains(e.target) &&
    !e.target.closest(".autocomplete-items") &&
    !e.target.closest("#location-navegador")
  ) {
    popup.style.display = "none";
  }
});

function openLocationPopup() {
  if (!popup) return;

  popup.style.display = "flex";

  // opcional: foco inicial
  const input = popup.querySelector('input');
  input?.focus();
}


function hasSelectedVendor() {
  const vendorId = localStorage.getItem("currentVendorId");
  return vendorId && vendorId !== "null";
}


/***********************
 * AUTOCOMPLETE
 ***********************/
function addressAutocomplete(container, callback) {
  const input = document.createElement("input");
  input.type = "text";
  input.placeholder = "¿Cuál es tu dirección?";
  container.appendChild(input);

  let currentPromiseReject;
  let currentItems;

  input.addEventListener("input", function () {
    const value = this.value;
    closeList();

    if (!value) return;

    if (currentPromiseReject) {
      currentPromiseReject({ canceled: true });
    }

    const promise = new Promise((resolve, reject) => {
      currentPromiseReject = reject;

      fetch(
        `https://api.geoapify.com/v1/geocode/autocomplete?text=${encodeURIComponent(
          value
        )}&limit=5&filter=countrycode:cl&apiKey=${geoApifyKey}`
      )
        .then((r) => r.json())
        .then(resolve)
        .catch(reject);
    });

    promise.then((data) => {
      currentItems = data.features;

      const list = document.createElement("div");
      list.className = "autocomplete-items";
      container.appendChild(list);

      data.features.forEach((feature, index) => {
        const item = document.createElement("div");
        item.innerHTML = feature.properties.formatted;

        item.addEventListener("click", (e) => {
          e.stopPropagation(); // 🔑 CLAVE
          input.value = feature.properties.formatted;
          callback(feature);
          closeList();
        });

        list.appendChild(item);
      });
    });
  });

  function closeList() {
    const list = container.querySelector(".autocomplete-items");
    if (list) list.remove();
  }

  document.addEventListener("click", (e) => {
    if (e.target !== input) closeList();
  });
}

/***********************
 * AUTOCOMPLETE CALLBACK
 ***********************/
addressAutocomplete(
  document.getElementById("autocomplete-container"),
  (data) => {
    const props = data.properties;

    selectedCoords = {
      lat: props.lat,
      lng: props.lon,
    };

    selectedGeoData = {
      street: props.street,
      housenumber: props.housenumber,
      city: props.city,
      municipality: props.municipality,
      state: props.state,
      address: props.formatted,
      lat: props.lat,
      lng: props.lon,
    };

    initMap(props.lat, props.lon);
    hideContentInfo();
  }
);

/***********************
 * GPS
 ***********************/
navegadorBtn.addEventListener("click", () => {
  if (!navigator.geolocation) {
    alert("Tu navegador no soporta geolocalización");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;

      selectedCoords = { lat, lng };

      const res = await fetch(
        `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&lang=es&apiKey=${geoApifyKey}`
      );
      const json = await res.json();
      const props = json.features[0]?.properties;

      if (props) {
        selectedCoords = { lat, lng };

  selectedGeoData = {
    street: props.street,
    housenumber: props.housenumber,
    city: props.city,
    municipality: props.municipality,
    state: props.state,
    address: props.formatted,
    lat,
    lng,
  };
      }

      initMap(lat, lng);
      hideContentInfo(); // 👈 AQUÍ
    },
    () => alert("No se pudo obtener tu ubicación")
  );
});

/***********************
 * MAPA
 ***********************/
function initMap(lat, lng) {
  if (!map) {
    map = L.map("map").setView([lat, lng], 16);

    const icon = L.icon({
      iconUrl: `https://api.geoapify.com/v1/icon/?type=material&icon=pets&color=%23ff0000&contentColor=%23ffffff&noWhiteCircle&apiKey=${geoApifyKey}`,
      iconSize: [36, 50],
      iconAnchor: [18, 50],
    });

    L.tileLayer(
      `https://maps.geoapify.com/v1/tile/carto/{z}/{x}/{y}.png?apiKey=${geoApifyKey}`,
      { maxZoom: 20 }
    ).addTo(map);

    marker = L.marker([lat, lng], {
      draggable: true,
      icon: icon
    }).addTo(map);

    marker.on("dragend", onMarkerMoved);
  } else {
    map.setView([lat, lng], 16);
    marker.setLatLng([lat, lng]);
  }

  setTimeout(() => map.invalidateSize(), 200);
}


async function onMarkerMoved(e) {
  const { lat, lng } = e.target.getLatLng();
  selectedCoords = { lat, lng };

  const res = await fetch(
    `https://api.geoapify.com/v1/geocode/reverse?lat=${lat}&lon=${lng}&lang=es&apiKey=${geoApifyKey}`
  );
  const json = await res.json();
  const props = json.features[0]?.properties;

  if (props) {
    selectedGeoData = {
      street: props.street,
      housenumber: props.housenumber,
      city: props.city,
      municipality: props.municipality,
      state: props.state,
      address: props.formatted,
      lat,
      lng,
    };
  }
}

/***********************
 * CONFIRMAR UBICACIÓN
 ***********************/
submitBtn.addEventListener("click", () => {
  if (!selectedGeoData) {
    alert("Selecciona una ubicación");
    return;
  }

const customer = normalizeGeoapifyCustomer(selectedGeoData);

  localStorage.setItem("checkoutCustomer", JSON.stringify(customer));
localStorage.setItem("userAddress", customer.address);
localStorage.setItem("userCity", customer.city);
localStorage.setItem("userLat", customer.lat);
localStorage.setItem("userLng", customer.lng);

  const cart = JSON.parse(localStorage.getItem("externalCart"));
  if (cart) {
    cart.customer = {
  ...cart.customer,
  ...customer
};

    localStorage.setItem("externalCart", JSON.stringify(cart));
  }

  popup.style.display = "none";
  location.reload();
});


function normalizeGeoapifyCustomer(data) {
  if (!data) return null;

  const direccion = [data.street, data.housenumber]
    .filter(Boolean)
    .join(" ");

  const comuna = data.city || data.municipality || "";

  return {
    // backend / firebase
    address: direccion || data.address || "",
    city: comuna,
    region: data.state || "",

    // frontend checkout
    direccion: direccion || data.address || "",
    comuna,

    lat: data.lat,
    lng: data.lng,
  };
}

